export default __webpack_public_path__ + "static/media/undo-inactive.2525365a.png";